import { useSiteCountryCode } from '@common/hooks/localisation';

export const useGetHomeLink = () => {
  const countryCode = useSiteCountryCode();
  return `/${countryCode}/`;
};
